/**
 * The app's top-level paths, written down once.
 *
 * A path is a value shared by everything that links to it, redirects to it,
 * matches the active nav tab against it, whitelists it in the proxy, or offers
 * it to the tutor as a navigation target. Moving a page means changing this
 * object, not grepping for a string.
 *
 * Paths *within* the curriculum tree are built by @lib/curriculum/paths, which
 * owns the /curriculum/[subjectId]/[chapterId]/[unitId]/[lessonId] shape.
 */
export const ROUTES = {
  home: "/",
  login: "/login",
  loginVerify: "/login/verify",
  curriculum: "/curriculum",
  curriculumHistory: "/curriculum/history",
  homework: "/homework",
  progress: "/progress",
  review: "/review",
  scenarios: "/scenarios",
  sessions: "/sessions",
  settings: "/settings",
  profile: "/profile",
  tutorMemory: "/profile/tutor-memory",
} as const;

export type AppRoute = (typeof ROUTES)[keyof typeof ROUTES];
